import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CargaDescargaFormRx } from "./form";
type Entity = models.CargaDescargaCajaRutaDto;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class CargaDescargaEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number {
        const id = this.props.match.params.id;
        return Number.parseInt(id);
    }
    async getValue() {
        return await resources.CargaDescarga.GetCargaDescarga(this.id);
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));


    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <CargaDescargaFormRx value={this.state.value} />;
    }
}

export const CargaDescargaEdit = withRouter(CargaDescargaEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/edit.tsx